import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const ReportSectionRoot = superstyled({
  name: 'StandaloneReportSection',
  slot: 'Root',
  tag: Box,
  propsNeeded: ['isBubble'],
  styles: ({ theme, isBubble = false }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.border.main}`,
    backgroundColor: isBubble ? '#E1EBFF' : 'transparent',
    borderRadius: theme.shape.borderRadius * (isBubble ? 1 : 0),
    padding: theme.spacing(isBubble ? 3 : 0),
    marginBottom: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(2),
      padding: theme.spacing(isBubble ? 3 : 0, isBubble ? 3 : 0)
    }
  })
});

export const SectionHeader = superstyled({
  name: 'StandaloneReportSection',
  slot: 'Header',
  tag: Box,
  propsNeeded: ['isBubble'],
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: theme.spacing(1.5),
    [theme.breakpoints.up('sm')]: {
      gap: theme.spacing(0)
    }
  })
});

export const SectionIcon = superstyled({
  name: 'StandaloneReportSection',
  slot: 'Icon',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(4),
    height: theme.spacing(4),
    minWidth: theme.spacing(4),
    borderRadius: theme.shape.borderRadius * 0.5,
    background: '#D1FDFF',
    color: '#3971E7',
    '& svg': {
      fontSize: theme.spacing(2.5),
      color: '#3971E7',
      fill: 'currentColor'
    }
  })
});

export const SectionTitle = superstyled({
  name: 'StandaloneReportSection',
  slot: 'Title',
  tag: Text,
  styles: ({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary
  })
});

export const SectionTitleSection = superstyled({
  name: 'StandaloneReportSection',
  slot: 'TitleSection',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'space-between'
    }
  })
});

export const CostRange = superstyled({
  name: 'StandaloneReportSection',
  slot: 'CostRange',
  tag: Text,
  styles: ({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    marginLeft: 'auto'
  })
});

export const SectionContent = superstyled({
  name: 'StandaloneReportSection',
  slot: 'Content',
  tag: Box,
  propsNeeded: ['isBubble'],
  styles: ({ theme, isBubble = false }) => ({
    lineHeight: 1.6,
    color: theme.palette.text.secondary,
    paddingLeft: 0,
    marginBottom: theme.spacing(isBubble ? 0 : 2.5),
    '& ul': {
      margin: 0,
      paddingLeft: theme.spacing(2)
    },
    '& li': {
      marginBottom: theme.spacing(0.5)
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0
    }
  })
});

export const SubsectionWrapper = superstyled({
  name: 'StandaloneReportSection',
  slot: 'SubsectionWrapper',
  tag: Box,
  propsNeeded: ['isBubble'],
  styles: ({ theme, isBubble = false }) => ({
    marginTop: theme.spacing(3),
    backgroundColor: isBubble ? '#E1EBFF' : 'transparent',
    borderRadius: theme.shape.borderRadius * (isBubble ? 1 : 0),
    padding: theme.spacing(isBubble ? 3 : 0),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(isBubble ? 3 : 0, isBubble ? 3 : 0)
    }
  })
});

export const SubsectionTitle = superstyled({
  name: 'StandaloneReportSection',
  slot: 'SubsectionTitle',
  tag: Text,
  styles: ({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary
  })
});

export const SubsectionContent = superstyled({
  name: 'StandaloneReportSection',
  slot: 'SubsectionContent',
  tag: Box,
  styles: () => ({
    lineHeight: 1.6
  })
});
